import {getEntityCreatorDisplayName, isSystemUser} from 'common/report/stores/user-details';
import {userCookieUtils} from 'common/report/util/user-identity-from-cookie';
import {isStaffEmail} from 'common/report/util';
import {MixpanelUserItem} from 'common/widgets/user-list/types';

export function getUserNameLabel(user: MixpanelUserItem) {
  const name = getEntityCreatorDisplayName(user.email || ``, user.name || ``);
  const currentUser = userCookieUtils.getUserIdentityFromCookie();
  const isCurrentUserSystem = currentUser ? isSystemUser({userId: currentUser.id}) : false;
  const isCurrentUserStaff = currentUser && currentUser.email ? isStaffEmail(currentUser.email) : false;
  const currentUserCanSeeFullName = isCurrentUserSystem || isCurrentUserStaff;
  if (isSystemUser({email: user.email})) return `${name}${currentUserCanSeeFullName ? ` <${user.email}>` : ``}`;
  const userIsCurrentUser = userCookieUtils.getUserIdentityFromCookie()?.id === user.id;
  return `${name}${userIsCurrentUser ? ` (you)` : ``} ${`<${user.email}>`}`;
}
